import { BusEvacuatie, usePatchBusEvacuatieStatus } from "@/entities/betrokken-treinen";
import { RoleGate } from "@/features/auth";
import { Button, ErrorDisplay, MessageBar } from "@/shared/components";

type BusEvacuatieCancelStatusProps = {
    dossierId: string;
    treinId: number;
    status: BusEvacuatie["status"];
};

function BusEvacuatieCancelStatusRegievoerder({ status }: Pick<BusEvacuatieCancelStatusProps, "status">) {
    switch (status) {
        case "AnnuleringAangevraagd":
            return (
                <MessageBar>
                    <span className="font-bold">Intrekking</span> van de evacuatiebus is aangevraagd bij regiecentrum bus.
                </MessageBar>
            );
        case "Geannuleerd":
            return (
                <MessageBar>
                    De evacuatiebus is <span className="font-bold">ingetrokken</span>.
                </MessageBar>
            );
    }
}

function BusEvacuatieCancelStatusRCB({ dossierId, treinId, status }: BusEvacuatieCancelStatusProps) {
    const mutation = usePatchBusEvacuatieStatus();

    const handleConfirm = () => {
        mutation.mutate({ dossierId, treinId, status: "Geannuleerd" });
    };

    switch (status) {
        case "AnnuleringAangevraagd":
            return (
                <>
                    <MessageBar>
                        De regievoerder heeft inzet van de evacuatiebus <span className="font-bold">ingetrokken</span>.
                    </MessageBar>
                    <div>
                        <Button onClick={handleConfirm} disabled={mutation.isPending}>
                            Intrekken bevestigen
                        </Button>
                        {mutation.error && <ErrorDisplay error={mutation.error} />}
                    </div>
                </>
            );
        case "Geannuleerd":
            return (
                <MessageBar>
                    De evacuatiebus is <span className="font-bold">ingetrokken</span>.
                </MessageBar>
            );
    }
}

function BusEvacuatieCancelStatus({ dossierId, treinId, status }: BusEvacuatieCancelStatusProps) {
    return (
        <>
            <RoleGate roles={["regievoerder"]}>
                <BusEvacuatieCancelStatusRegievoerder status={status} />
            </RoleGate>
            <RoleGate roles={["dewit", "transvision"]}>
                <BusEvacuatieCancelStatusRCB dossierId={dossierId} treinId={treinId} status={status} />
            </RoleGate>
        </>
    );
}

export default BusEvacuatieCancelStatus;
